export default (luggage = '') =>
  luggage.substr(0, 2) === '5B'
    ? Number(luggage.substr(2, luggage.length))
    : null
